module.exports = __webpack_public_path__ + "img/icn_school_on.aed83ad5.svg";